import { render, staticRenderFns } from "./student-list.vue?vue&type=template&id=2c427d6a&scoped=true&"
import script from "./student-list.vue?vue&type=script&lang=js&"
export * from "./student-list.vue?vue&type=script&lang=js&"
import style0 from "./student-list.vue?vue&type=style&index=0&id=2c427d6a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c427d6a",
  null
  
)

export default component.exports